import React, { useContext } from "react";
import "../css/Navbar.css";
import logo from "../Assets/medicalbook logo.jpg";
import { Link } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import {
  FaHome,
  FaUserPlus,
  FaSignInAlt,
  FaSignOutAlt,
  FaUserShield,
  FaUser,
  FaTicketAlt,
  FaChartPie,
} from "react-icons/fa";
import { motion } from "framer-motion";

const NavItem = ({ to, icon, children, variant }) => (
  <li className="nav-item mx-1">
    <motion.div whileHover={{ y: -1 }} transition={{ type: "spring", stiffness: 300 }}>
      <Link className={`nav-link app-nav-link ${variant ? `app-nav-link--${variant}` : ""}`} to={to}>
        <span className="app-nav-link__icon">{icon}</span>
        {children}
      </Link>
    </motion.div>
  </li>
);

const Navbar = () => {
  const { user } = useContext(AuthContext);

  return (
    <nav className="navbar navbar-expand-lg sticky-top app-navbar">
      <div className="container-fluid px-3 px-lg-5">
        <Link className="navbar-brand d-flex align-items-center app-navbar__brand" to="/">
          <img src={logo} alt="Helan Homeopathy logo" width="38" height="38" className="me-2 rounded" />
          <span className="fw-bold fs-4">HELAN HOMEOPATHY</span>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center">
            <NavItem to="/" icon={<FaHome />}>
              Home
            </NavItem>

            {!user ? (
              <>
                <NavItem to="/register" icon={<FaUserPlus />}>
                  Register
                </NavItem>
                <NavItem to="/login" icon={<FaSignInAlt />}>
                  Login
                </NavItem>
                <NavItem to="/adminlogin" icon={<FaUserShield />}>
                  Admin Login
                </NavItem>
              </>
            ) : user.role === "ROLE_ADMIN" ? (
              <NavItem to="/logout" icon={<FaSignOutAlt />} variant="danger">
                Logout
              </NavItem>
            ) : user.role === "ROLE_CUSTOMER" ? (
              <>
                <NavItem to="/customer/profile" icon={<FaUser />}>
                  Profile
                </NavItem>
                <NavItem to="/customer/tickets" icon={<FaTicketAlt />}>
                  Tickets
                </NavItem>
                <NavItem to="/customer/dashboard" icon={<FaChartPie />}>
                  Dashboard
                </NavItem>
                <NavItem to="/logout" icon={<FaSignOutAlt />} variant="danger">
                  Logout
                </NavItem>
              </>
            ) : null}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
